const getOptionText = (option) => {
  if (typeof option.content === 'string') {
    return option.content;
  }

  if (typeof option.children === 'string') {
    return option.children;
  }

  if (option.text) {
    return option.text;
  }

  return option.value;
};

export const getSelectedOptionContent = (options, value) => {
  if (!value) return;

  const selectedOption = options?.find((opt) => opt.value === value);

  if (!selectedOption) return;

  return getOptionText(selectedOption);
};
